var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    rx: 10,
    fill: "#FEFFBB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8231 16.7928C17.8231 16.1802 18.3198 15.6835 18.9324 15.6835H27.0676C27.6803 15.6835 28.1769 16.1802 28.1769 16.7928V29.2051C28.1769 30.1215 27.1287 30.6427 26.398 30.0896L23.6695 28.0243C23.2735 27.7246 22.7265 27.7246 22.3305 28.0243L19.6019 30.0896C18.8713 30.6427 17.8231 30.1215 17.8231 29.2051V16.7928Z",
    fill: "#98D763"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.9542 23.1332L21.6227 23.9629C21.5099 24.0332 21.3689 23.9307 21.4009 23.8018L21.7786 22.2791L20.578 21.2692C20.4763 21.1836 20.5302 21.0179 20.6627 21.0084L22.2276 20.8971L22.8171 19.4432C22.867 19.32 23.0413 19.32 23.0912 19.4432L23.6807 20.8971L25.2456 21.0084C25.3781 21.0179 25.432 21.1836 25.3303 21.2692L24.1298 22.2791L24.5074 23.8018C24.5394 23.9307 24.3984 24.0332 24.2856 23.9629L22.9542 23.1332Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTag);
export default __webpack_public_path__ + "static/media/tag.821e968377c300211d9c7d3b92803e0c.svg";
export { ForwardRef as ReactComponent };